'use client';
import { SectionContainer } from '../component/SectionContainer';
import Tabs, { TabPane } from '../_bs-components/TabCarousel';
import GuestCardGrid from '../_bs-components/GuestCardGrid';
import TabTitle from '../_bs-components/TabTitle';
import { ForumItem } from '../type';
import { getCMSIntlVal } from '../utils/common';
import { useLocale, useTranslations } from 'use-intl';
import { useMedia } from '@ssv-website/hooks';

export default function MeetingGuestSection({
  data,
  title,
}: {
  data: ForumItem[];
  title: string;
}) {
  // 过滤嘉宾无需展示的tab
  data = data.filter((item) => !Number(item.isGuestListHidden));
  const defaultKey = data[0].id;
  const t = useTranslations('s2025');
  const locale = useLocale();
  const isMobile = useMedia('mobile');
  return (
    <SectionContainer
      title={
        <>
          <span>{title}</span>
          <span className="text-2xl text-[#121C59] opacity-80 font-300 mobile:text-base">
            {locale !== 'en' && t('（按发言次序排列）')}
          </span>
        </>
      }
      titleClassName="mobile:!mb-4"
      contentClassName="mobile:max-w-full mobile:!px-0"
    >
      <Tabs
        activeKey={defaultKey}
        disableDrag={true}
        openSticky={isMobile}
        stickyOffset={60}
        titleClassName="mobile:top-12 bg-[#EDF3FF]"
        titleScrollClassName="mobile:ml-5"
        titleContentClassName="mobile:mr-5"
        paneScrollClassName="mobile:ml-5"
      >
        {data.map((item) => {
          const { guestList } = item;
          const name = getCMSIntlVal(item, 'name', locale);
          const desc = getCMSIntlVal(item, 'desc', locale);
          return (
            <TabPane
              key={item.id}
              tabKey={item.id}
              title={({ isActive }) => {
                return (
                  <TabTitle title={name} subTitle={desc} isActive={isActive} />
                );
              }}
            >
              <GuestCardGrid list={guestList}></GuestCardGrid>
            </TabPane>
          );
        })}
      </Tabs>
    </SectionContainer>
  );
}
